import { render, staticRenderFns } from "./KostenGesamtVergleich.vue?vue&type=template&id=1a0f0e55&"
import script from "./KostenGesamtVergleich.vue?vue&type=script&lang=ts&"
export * from "./KostenGesamtVergleich.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports